export type PatchNoteEntry = {
  date: string;
  items: string[];
};

export const patchNotesData: PatchNoteEntry[] = [
  {
    "date": "17 April 2026",
    "items": [
      "Integration Center akan segera hadir sebagai pusat koneksi HRM, Accounting, dan CRM dalam satu halaman yang lebih rapi, cepat, dan mudah dipahami. Lihat preview.",
      "Satu pusat kontrol: tim tidak perlu bolak-balik buka banyak project hanya untuk cek koneksi dan jalankan sinkronisasi.",
      "1 klik semua data tersinkron: client, customer, contact, project, quotation, invoice, reimburse, payroll, dan data penting lain akan semakin mudah diselaraskan antar platform.",
      "Status koneksi lebih jelas: admin bisa langsung melihat platform mana yang sehat, mana yang perlu perhatian, dan mana yang belum terhubung.",
      "Lebih minim input ulang: tujuan utamanya adalah membuat operasional lebih hemat waktu, lebih konsisten, dan lebih nyaman saat bisnis client mulai berkembang.",
      "Cocok untuk multi-project: sangat ideal untuk perusahaan yang memakai kombinasi HRM + Accounting saja, maupun HRM + Accounting + CRM sekaligus."
    ]
  },
  {
    "date": "02 April 2026",
    "items": [
      "Optimasi Performa Server: kami telah melakukan peningkatan performa server, jaringan, dan teknologi yang kami gunakan. Saat ini akses Kolabo jauh lebih cepat terutama di jam sibuk.",
      "Dampak: proses attendance, lembur, approval, dan seluruh fitur di ekosistem Kolabo jauh lebih cepat.",
      "Tidak ada perubahan cara pakai aplikasi, seluruh fitur tetap digunakan seperti biasa.",
      "Tim kami tetap memantau performa secara berkala untuk menjaga kestabilan layanan."
    ]
  },
  {
    "date": "27 Maret 2026",
    "items": [
      "Google Documents sekarang sudah terintegrasi di Kolabo untuk membantu Anda mengelola dokumen kerja harian dalam satu tempat. Cek di sini.",
      "Anda bisa menghubungkan akun Google, melihat daftar file, membuat folder, dan memindahkan dokumen tanpa perlu buka banyak halaman.",
      "Dokumen bisa langsung dibuka untuk diedit di Google, lalu saat Anda kembali ke dashboard informasinya otomatis diperbarui.",
      "Tersedia tampilan Grid, Compact, dan List agar Anda lebih nyaman melihat arsip sesuai gaya kerja.",
      "Benefit: pencarian dokumen lebih cepat, arsip lebih rapi, dan pekerjaan harian jadi lebih hemat waktu."
    ]
  },
  {
    "date": "23 Maret 2026",
    "items": [
      "Calendar Hub sekarang tersedia untuk membantu Anda melihat agenda kerja dari berbagai fitur dalam satu halaman.",
      "Kalender ini menampilkan data penting seperti kehadiran, cuti, proyek, tugas, persetujuan, note, meeting, reimburse, payroll, dan data lain yang relevan.",
      "Anda juga bisa menambahkan reminder pribadi agar tindak lanjut harian tidak terlewat.",
      "Terintegrasi dengan kalender di aplikasi dan Kolabo Meet serta Anda akan mendapatkan notifikasi.",
      "Data yang tampil tetap aman karena mengikuti hak akses role masing-masing."
    ]
  },
  {
    "date": "15 Maret 2026",
    "items": [
      "Dashboard sekarang hadir dengan pembaruan baru untuk mendukung kerja harian Anda.",
      "Ringkasan Utama + View More : informasi penting langsung terlihat lebih cepat, dan detail lengkap tetap bisa dibuka saat dibutuhkan.",
      "Activity Hub : antrean persetujuan jadi lebih jelas. Menu Forms untuk antrean form Anda cek di sini dan Approval Hub untuk antrean gabungan cek di sini.",
      "Quick Access : tersedia 5 menu utama bawaan yang bisa Anda ubah atau tambah, jadi pekerjaan rutin lebih hemat waktu.",
      "Smart Audit : membantu menandai hal penting yang perlu perhatian lebih awal agar tindak lanjut lebih cepat.",
      "Company Org Chart + Export PDF : melihat struktur tim lebih mudah, lebih rapi, dan siap dibagikan dalam bentuk PDF.",
      "Floating Menu Navigasi : berpindah ke bagian dashboard jadi lebih cepat tanpa perlu scroll panjang.",
      "Akses sesuai role : setiap orang hanya melihat menu yang memang diizinkan, sehingga data lebih aman."
    ]
  },
  {
    "date": "13 Maret 2026",
    "items": [
      "Multi Approval & Digital Sign sekarang sudah tersedia di Kolabo Accounting.",
      "Dokumen sekarang bisa melewati lebih dari satu tahap persetujuan.",
      "Setiap approver bisa menyetujui atau menolak sambil memberi catatan.",
      "Tanda tangan digital per pengguna juga sudah bisa digunakan dalam proses persetujuan.",
      "Jika dokumen masih menunggu persetujuan, proses berikutnya belum bisa dilanjutkan.",
      "Status persetujuan bisa langsung dilihat pada dokumen.",
      "Modul yang sudah mendukung: Invoice, Bill, Quotation, Payment, Modal & Prive, Jurnal Umum, Rekonsiliasi Bank, dan Depresiasi Aset.",
      "Smart Audit sekarang sudah hadir untuk membantu melihat kondisi keuangan bisnis dalam satu halaman.",
      "Menampilkan skor kesehatan keuangan per periode.",
      "Ada ringkasan temuan dari yang paling penting sampai yang ringan.",
      "Ada daftar tindakan yang perlu didahulukan agar tim tahu harus mulai dari mana.",
      "Temuan juga bisa difilter berdasarkan periode, project, prioritas, modul, dan kata kunci.",
      "Hasilnya bisa diunduh untuk dibagikan ke tim.",
      "Membantu penutupan bulanan jadi lebih rapi karena masalah penting lebih cepat terlihat."
    ]
  },
  {
    "date": "12 Maret 2026",
    "items": [
      "AI Chat Assistant sekarang hadir di dashboard untuk membantu Anda memahami fitur Kolabo dengan lebih cepat.",
      "Cukup ketik pertanyaan, lalu sistem akan menjawab dengan penjelasan yang mudah dipahami.",
      "Jawaban juga dilengkapi langkah penggunaan per menu agar lebih gampang diikuti.",
      "Riwayat chat tersimpan sementara, jadi percakapan bisa dilanjutkan tanpa mulai dari awal.",
      "Manfaatnya, tim lebih cepat memahami fitur, mengurangi tanya ulang, dan pekerjaan harian jadi lebih lancar.",
      "Accounting Sync sekarang tersedia untuk membantu mengirim data penting dari HRM ke Accounting dengan lebih rapi.",
      "Data yang bisa dikirim: Client, Project, Reimburse, Payroll, Kasbon, Tabungan & Pinjaman, dan Expense.",
      "Proses sinkron berjalan saat Anda menekan tombol sinkron, jadi waktunya bisa Anda atur sendiri.",
      "Jika memilih sinkron semua modul, sistem hanya akan memproses data yang belum pernah dikirim agar tidak dobel.",
      "Hasilnya, data HRM dan Accounting jadi lebih selaras, lebih minim input ulang, dan lebih mudah dicek kembali.",
      "Depresiasi Aset sekarang sudah tersedia di Accounting.",
      "Nilai aset bisa dipantau per periode dengan lebih jelas.",
      "Nilai awal, total penyusutan, dan nilai buku aset jadi lebih mudah dibaca.",
      "Modal & Prive juga sudah ditambahkan.",
      "Mendukung modal awal, tambah modal, dan prive atau tarik modal.",
      "Setiap transaksi tercatat otomatis agar pergerakan modal lebih rapi.",
      "Rekonsiliasi sekarang tersedia lebih lengkap.",
      "Membantu mengecek kesesuaian data keuangan.",
      "Selisih jadi lebih mudah ditemukan dan ditindaklanjuti.",
      "Laporan Stok sekarang sudah ditambahkan.",
      "Pergerakan barang dari penjualan dan pembelian jadi lebih mudah dipantau.",
      "Fitur Project di Accounting sekarang sudah tersedia.",
      "Data bisa difilter berdasarkan project.",
      "Tersedia pencarian dan ekspor data per project.",
      "Laporan keuangan per project juga sudah disiapkan.",
      "RAB & RAP sekarang mendukung import data massal.",
      "Beberapa bagian yang sebelumnya bermasalah juga sudah diperbaiki.",
      "Sub Invoice sekarang sudah didukung.",
      "Invoice turunan bisa dibuat agar pengelolaan tagihan bertahap lebih rapi.",
      "Return Barang Sebagian sekarang sudah tersedia.",
      "Pengembalian barang tidak harus semuanya.",
      "Jumlah barang dan nilai tagihan akan menyesuaikan otomatis.",
      "Perbaikan Tampilan juga sudah dilakukan di beberapa halaman.",
      "Tampilan form aset dibuat lebih nyaman.",
      "Halaman modal & prive juga dirapikan agar lebih bersih dan mudah dibaca."
    ]
  },
  {
    "date": "10 Maret 2026",
    "items": [
      "Payroll Account sekarang mendukung pengaturan potongan ketidakhadiran yang lebih fleksibel.",
      "Potongan absen atau tidak hadir sekarang bisa mengikuti nominal harian custom yang Anda tentukan.",
      "Potongan unpaid leave per hari juga bisa dibuat dengan nominal custom sesuai kebijakan perusahaan.",
      "Project Management (View Permission) sekarang tersedia agar akses project lebih aman.",
      "Pembuat project dan admin bisa menentukan siapa saja yang boleh melihat detail project.",
      "Pilihan user bisa dilakukan per department, per jabatan, atau dipilih satu per satu.",
      "Hasilnya, data project, task, dan checklist jadi lebih terjaga karena hanya user tertentu yang bisa melihat."
    ]
  },
  {
    "date": "09 Maret 2026",
    "items": [
      "Update Overtime sekarang memungkinkan lembur dicatat lebih dari satu kali dalam satu hari.",
      "Jika karyawan lembur siang lalu lanjut lembur malam di tanggal yang sama, semua riwayat tetap tersimpan.",
      "Total jam lembur di payroll tetap dijumlahkan sesuai data yang valid.",
      "Di slip gaji, rincian lembur jadi tampil lebih lengkap dan lebih jelas dibaca."
    ]
  },
  {
    "date": "09 Maret 2026",
    "items": [
      "360 Feedback sekarang sudah tersedia di Kolabo.",
      "Karyawan bisa saling memberi penilaian dalam periode yang ditentukan perusahaan.",
      "Admin cukup atur periode, peserta, dan pertanyaan, lalu sistem akan mencatat prosesnya otomatis.",
      "Hasilnya membantu perusahaan melihat kelebihan dan area pengembangan karyawan dengan lebih jelas.",
      "LMS sekarang lebih lengkap: selain video, materi juga mendukung attachment dan quiz .",
      "Admin bisa menambahkan file pendukung lewat link Google Drive agar materi belajar lebih lengkap.",
      "Admin juga bisa membuat quiz untuk cek pemahaman setelah karyawan menonton materi.",
      "Benefitnya, proses training jadi lebih terukur, rapi, dan progres belajar lebih mudah dipantau."
    ]
  },
  {
    "date": "08 Maret 2026",
    "items": [
      "Kolabo Canteen sudah hadir untuk membantu proses request dan claim makanan karyawan.",
      "Karyawan bisa request menu lewat aplikasi.",
      "Saat pengambilan, makanan bisa di-claim lebih cepat dengan scan QR/Barcode ID Card.",
      "Admin bisa memantau request, status claim, riwayat, dan pengaturan menu per shift/cabang dari dashboard."
    ]
  },
  {
    "date": "09 Februari 2026",
    "items": [
      "Timesheet (Pencatatan Aktivitas & Jam Kerja) — kini hadir dengan sistem yang lebih akurat untuk memantau penggunaan jam kerja karyawan secara detail, mulai dari produktivitas hingga estimasi biaya kerja.",
      "Timer Real-Time (Start/Stop) : Karyawan bisa menjalankan timer saat mulai bekerja dan menghentikannya saat selesai atau istirahat (Pause), sehingga durasi kerja tercatat hingga hitungan detik.",
      "Log Aktivitas Terperinci : Setiap timesheet mencatat riwayat kapan timer dijalankan, dijeda (pause), dan dilanjutkan , memudahkan admin memverifikasi kebenaran jam kerja.",
      "Input Bukti & Lampiran : Saat menyelesaikan tugas, karyawan dapat mengunggah multiple file/gambar sebagai bukti hasil kerja beserta rangkuman singkat aktivitasnya.",
      "Koneksi ke Service & Project : Setiap catatan waktu dapat dikaitkan dengan jenis layanan (Service) atau Project tertentu untuk mempermudah laporan biaya jasa ke klien.",
      "Manajemen Tugas (Daily & One-time) : Mendukung tugas rutin harian maupun tugas sekali jalan. Jika tugas tidak memerlukan timer, karyawan tetap bisa memberikan laporan penyelesaian manual.",
      "Laporan & Dashboard Timesheet : Admin dapat melihat total jam kerja tim per periode, memantau tugas mana yang memakan waktu paling banyak, dan mengevaluasi efisiensi kerja.",
      "Otomatisasi Status : Sistem secara otomatis mendeteksi jika ada timer yang masih berjalan (Running) atau sedang dijeda (Paused), sehingga tidak ada jam kerja yang terlewat atau tumpang tindih.",
      "Laporan & Ekspor Timesheet : Admin dapat mengunduh laporan durasi kerja dalam format Excel untuk menganalisa produktivitas, menghitung beban kerja (workload), serta menjadi bahan evaluasi performa karyawan yang lebih objektif.",
      "Terintegrasi dengan Task Checklist : Fitur Timesheet kini menyatu dengan Task Checklist; Anda bisa mengubah tugas rutin menjadi pencatatan waktu hanya dengan mengaktifkan opsi \"Use Timer\" , sehingga setiap progres kerja terdokumentasi durasinya secara otomatis.",
      "Log Riwayat Transparan : Setiap aktivitas mencatat detik demi detik perubahan status (kapan dijalankan, siapa yang memulai, dan kapan dijeda). Riwayat ini memberikan data yang adil bagi karyawan maupun manajemen karena tidak dapat dimanipulasi manual.",
      "Cara pakai cepat: Pilih Tugas (Task) → Klik Mulai (Start Timer) → Jeda bila perlu (Pause) → Selesaikan (Stop/Finish) → Upload Bukti & Isi Rangkuman → Ajukan → Admin Review & Approve → Cek Laporan Durasi & Aktivitas."
    ]
  },
  {
    "date": "05 Februari 2026",
    "items": [
      "KPI V2.0 (Penilaian Kinerja) — fitur KPI sekarang lebih rapi, lebih fleksibel, dan punya laporan yang enak dibaca untuk memantau performa karyawan dari waktu ke waktu.",
      "Template KPI (Siap Pakai) : Admin bisa membuat template aspek penilaian agar tidak perlu input ulang setiap kali.",
      "Template bisa dibedakan : Template KPI dapat dibuat berdasarkan User tertentu , Department , atau Jabatan/Post (contoh: Sales beda KPI dengan Finance).",
      "Generate KPI otomatis : KPI bisa digenerate dari template ke banyak karyawan sekaligus untuk periode yang dipilih (hemat waktu untuk penilaian rutin).",
      "Masih bisa disesuaikan : Setelah generate, aspek/indikator tetap bisa diubah/ditambah/dikurangi sesuai kondisi karyawan atau kebutuhan periode tersebut.",
      "Import KPI dari Excel : Admin bisa download sample Excel berdasarkan template, isi kolom Realisasi , lalu upload untuk mengisi nilai KPI massal lebih cepat (cocok untuk data manual yang banyak).",
      "Penilaian berbasis aspek/indikator : Admin bisa membuat poin penilaian sesuai kebutuhan (contoh: Disiplin, Produktivitas, Ketepatan Waktu, Kerja Sama, Kualitas Kerja, dll).",
      "Mendukung bobot & formula : Setiap aspek bisa dibuat punya bobot (nilai lebih penting) dan bisa memakai rumus (formula) agar perhitungan nilai lebih adil dan otomatis.",
      "Periode penilaian jelas : KPI dibuat berdasarkan tanggal mulai dan tanggal selesai , jadi hasil penilaian tidak tercampur antar periode.",
      "Total Score otomatis : Nilai dari tiap aspek dirangkum otomatis menjadi Total Score , jadi hasil akhirnya langsung terlihat tanpa hitung manual.",
      "Status penilaian lebih tertib : KPI punya alur Draft (belum final) → Diajukan → Disetujui atau Ditolak , supaya proses review rapi dan bisa dipertanggungjawabkan.",
      "Riwayat aman : Setiap perubahan tercatat (tanggal dibuat & diperbarui) sehingga mudah dilacak.",
      "Laporan KPI bulanan & tahunan : Ada ringkasan performa berdasarkan periode (bulan/tahun) agar mudah melihat tren naik-turun performa tim.",
      "Top Score & ranking : Sistem bisa menampilkan karyawan dengan nilai tertinggi per periode (misal top 5/top 10) untuk kebutuhan evaluasi, reward, atau promosi.",
      "Grafik & insight : KPI dilengkapi grafik supaya lebih mudah dipahami (contoh: perbandingan skor antar karyawan, tren skor dari bulan ke bulan, dll).",
      "Cara pakai cepat: Buat Template KPI (user/department/post) → pilih periode → Generate KPI massal atau Import via Excel → sesuaikan bila perlu → simpan (Draft) → ajukan → Approve/Reject → lihat laporan bulanan/tahunan & grafik."
    ]
  },
  {
    "date": "06 Januari 2026",
    "items": [
      "Penalty Point untuk mencatat pelanggaran kedisiplinan karyawan dan (opsional) menghitung potongan gaji otomatis.",
      "Rules: Admin membuat aturan (mis. Telat ≥ X menit → poin + potongan %, Pulang lebih awal jika jam kerja < X jam → poin + potongan %, Leave tertentu → penalty khusus).",
      "Sync (Tarik Data): sistem membaca data yang sudah ada, mencari kejadian yang kena aturan, lalu menyimpan hasilnya sebagai Log.",
      "Sync to Payroll: dari Rekap Penalty, potongan dapat disisipkan otomatis ke periode payroll yang dipilih.",
      "Export: Rekap Penalty dapat diekspor ke Excel."
    ]
  },
  {
    "date": "07 Desember 2025",
    "items": [
      "View Data Permission: membatasi role tertentu melihat data role lain (attendance, overtime, payroll, dan pengajuan lainnya).",
      "Attachment Karyawan: di detail user/karyawan tersedia attachment + judul untuk menyimpan dokumen (SP, kontrak, surat jabatan, dll).",
      "Employee Contract Improvement: kontrak karyawan mendukung import dan multiple periode untuk memudahkan cek riwayat.",
      "Detail Overtime di Slip Gaji: slip gaji menampilkan detail lembur (mulai, selesai, dan status approval) per karyawan.",
      "Payroll Custom Improvement: payroll custom dapat dipakai untuk slip pesangon/kompensasi serta slip THR terpisah.",
      "Export BCA Payroll: export ringkasan gaji di Payroll Management sudah mendukung format Bank BCA."
    ]
  },
  {
    "date": "30 September 2025",
    "items": [
      "Visit Plan / Visit Route: atur agar visit karyawan wajib sesuai titik/route (geofence) yang Anda tetapkan.",
      "Mode ON: karyawan hanya bisa check-in/out di titik yang dibuat & di-assign (berdasarkan radius meter). Di luar titik/belum di-assign → ditolak.",
      "Mode OFF: karyawan bisa visit di lokasi mana saja (tanpa validasi titik/route).",
      "Aktifkan/Nonaktifkan: App Settings → Visit Based on Route/Plan (default: OFF).",
      "Manajemen Visit Plan / Route:",
      "Buat Group (mis. wilayah/klien/campaign) di Visit Plan.",
      "Tambah Titik (Geofence): isi label, alamat (opsional), lat/lng, dan radius (meter).",
      "Assign User: pilih karyawan, set periode aktif (mulai–selesai), dan status.",
      "Hasil: saat Mode ON, visit hanya lolos jika user berada dalam radius salah satu titik yang di-assign pada periode aktif."
    ]
  },
  {
    "date": "28 September 2025",
    "items": [
      "Attendance Simple Export: tambahan rekap data Total Attendance, Total Absent, Late Minutes, Early Times, dan Overtime (h)."
    ]
  },
  {
    "date": "23 September 2025",
    "items": [
      "Payroll Custom Improvement: saat generate payroll custom kini bisa menonaktifkan basic salary bawaan, kalkulasi absensi otomatis, tunjangan bawaan, dan pengurangan bawaan.",
      "Recruitment Improvement: kandidat per stage dapat diklik untuk memudahkan proses kurasi.",
      "Panduan penggunaan ditambahkan di Payroll Account dan Payroll Management."
    ]
  },
  {
    "date": "18 September 2025",
    "items": [
      "Recruitment Module — Ringkas & Jelas: kelola lowongan, kandidat, dan proses rekrutmen hingga onboarding.",
      "Jobs & Career Page: buat/kelola job, atur publikasi, bagikan tautan karier; admin melihat tautan detail job langsung.",
      "Pipelines/Stages: susun tahap (Screening, Interview, Offering, dst). Saat pindah stage, wajib isi remark agar keputusan terdokumentasi.",
      "Applications & Candidates: pantau pelamar per job, riwayat aksi, dan ringkasan kandidat (nama, email, telepon) + lowongan yang dilamar.",
      "Undangan Interview: generator pesan Email/WhatsApp (tanggal, waktu, zona waktu, lokasi/link meeting, durasi, catatan) + auto log.",
      "Offer & Onboarding: kirim offer, tandai accepted, lalu Onboard untuk buat akun karyawan.",
      "Alur Cepat: Buat Job → Tambah Stage → Bagikan link → Review aplikasi → Move Stage (isi remark) → Undang Interview → Kirim Offer → Onboard.",
      "Kolabo Form — Pending Approval List: tampilan cepat untuk melihat submission yang segera butuh approval."
    ]
  },
  {
    "date": "12 September 2025",
    "items": [
      "Kolabo AI — Meeting Recap (di aplikasi): merangkum ringkasan, keputusan, dan action items dari rekaman meeting.",
      "Asset Depreciation (Depresiasi Aset): hitung penyusutan otomatis per bulan sejak Purchased Date.",
      "Metode: Straight Line, Double Declining, Rate (%), Fixed Amount.",
      "Field kunci: Useful Life (bulan), Salvage Value, Rate/Fixed (opsional), Start Date (default = Purchased Date).",
      "Hasil: jadwal penyusutan bulanan (akhir bulan), akumulasi, nilai buku; otomatis berhenti saat nilai buku = nilai sisa.",
      "Cara pakai: Assets → Create/Edit → Depreciation → isi → Simpan."
    ]
  },
  {
    "date": "10 September 2025",
    "items": [
      "Task Checklist (Aplikasi): upload banyak bukti (gambar/dokumen) + ringkasan saat menyelesaikan checklist (butuh update app terbaru).",
      "Task Checklist (Dashboard): tampilan detail task baru, modern, mendukung multiple evidence."
    ]
  },
  {
    "date": "9 September 2025",
    "items": [
      "Generate Public Report Link (Client): tautan publik untuk klien memantau progres proyek langsung di browser.",
      "Cara pakai: Clients → Generate Report Link → atur (aktif, password/kedaluwarsa opsional) → Simpan → Copy Link.",
      "Keamanan: password opsional, tanggal kedaluwarsa, Rotate Token untuk mencabut link lama.",
      "Manfaat: hemat waktu, data selalu terbaru, bisa dicabut kapan saja, tersedia ekspor PDF."
    ]
  },
  {
    "date": "8 September 2025",
    "items": [
      "Multi Attendance Location: user/staff dapat memiliki banyak lokasi attendance (check in/out), tidak hanya branch utama. Atur via Employee Management → Edit → Additional Attendance Location (Branch)."
    ]
  },
  {
    "date": "7 September 2025",
    "items": [
      "Kolabo Form — Request Self Selection Approval: admin menentukan siapa yang boleh approve; saat isi form, user memilih approver (cukup satu/harus semua sesuai pengaturan).",
      "Kolabo Form — Multi Layer Approval: approval bertahap (Step 1, Step 2, dst); lanjut otomatis jika tahap aktif sudah disetujui; berhenti jika ada penolakan; bisa digabung dengan Self Selection.",
      "Kolabo Form — Notification: notifikasi ke approver & pihak terkait (in-app + push ke ponsel); seluruh notifikasi tersimpan.",
      "Kolabo Form — UI/UX Improvement: field bisa diedit langsung tanpa hapus & buat ulang.",
      "Kolabo Form — Field Baru: Uang (Rp), Rentang Tanggal (auto hitung hari), Kontak (pilih karyawan), Rumus (auto hitung), Total (auto jumlah), Multiselect.",
      "Kolabo Form — Field Formula: rumus otomatis antar field (contoh: field_1 * field_2 / 10000 ).",
      "Kolabo Form — Export PDF Improvement: tampilkan status akhir (Disetujui/Proses/Ditolak), urutan approver, lampiran, dan nama kontak."
    ]
  },
  {
    "date": "3 September 2025",
    "items": [
      "Client Management bisa dilakukan via aplikasi / app.kolabo.biz .",
      "Logo Company ditampilkan di halaman utama aplikasi.",
      "Visit Attendance History bisa dilihat langsung oleh user di aplikasi."
    ]
  },
  {
    "date": "20 Agustus 2025",
    "items": [
      "Create Team Meeting di dashboard terintegrasi Google Calendar.",
      "Kolabo Form — Visibility: atur form untuk semua orang atau role tertentu (tombol “View Permission”).",
      "Status Approval di PDF Kolabo Form.",
      "Kasbon/Cash Advance otomatis menjadi pengurangan saat payroll digenerate (untuk kasbon approve/partial paid)."
    ]
  },
  {
    "date": "8 Agustus 2025",
    "items": [
      "Popup Banner (Aplikasi): tampilkan gambar/banner ke seluruh user (butuh update app terbaru).",
      "Content Management — Rule & TnC: editor mendukung upload file (butuh update app terbaru).",
      "Payroll Harian/Mingguan/Range Tanggal: buat payroll di luar tanggal cut off dengan tanggal fleksibel.",
      "Kolabo Form (Aplikasi): status lebih detail; pending menampilkan approver, reject menampilkan alasan."
    ]
  },
  {
    "date": "14 Juni 2025",
    "items": [
      "Kanban Board hadir di Kolabo.",
      "Switch Tampilan Project: bisa kembali ke tampilan “List”.",
      "Kanban per Client: tiap client memiliki board terpisah, fleksibel.",
      "Info Lokasi Project di Board akan ditampilkan di app/web (Coming Soon)."
    ]
  },
  {
    "date": "13 Juni 2025",
    "items": [
      "Kolabo Form — Field Dinamis “Repeatable” di setiap field.",
      "Kolabo Form — Export PDF untuk setiap submission (format formal).",
      "Download PDF Submission via aplikasi.",
      "Asset — QR Code bisa discan di menu “Assets”."
    ]
  },
  {
    "date": "25 Mei 2025",
    "items": [
      "Self Shift Change: izinkan user mengganti shift sendiri via App Settings (aktifkan “Users Can Change Shift or Office Times Themselves”); ganti via app terbaru (Home → “View Office Time”)."
    ]
  },
  {
    "date": "23 Mei 2025",
    "items": [
      "Kolabo Form hadir! Buat form submission sesuka hati, terima submission via aplikasi, atur kondisi approval."
    ]
  },
  {
    "date": "11 Mei 2025",
    "items": [
      "Denda Keterlambatan: bisa berbasis interval/fix + batas per hari (contoh interval 15 menit = tiap 15 menit dihitung 1 satuan denda).",
      "Checklist Task (Aplikasi): bisa tambah bukti foto saat checklist selesai (butuh update app)."
    ]
  },
  {
    "date": "4 Mei 2025",
    "items": [
      "Tanggal Cut Off Payroll per Cabang; jika kosong di cabang → ikut tanggal cut off company.",
      "Tunjangan Tidak Tetap: pembagian berdasarkan total hari kerja dibagi kehadiran prorata."
    ]
  },
  {
    "date": "26 April 2025",
    "items": [
      "Supervisor: approve/reject lembur, leave, dan reimburse bawahan.",
      "Shift Management / Office Time Bulanan: atur jam kerja berbeda per tanggal untuk tiap user (Import Monthly Shift).",
      "Pengajuan Lembur (Aplikasi): popup otomatis saat checkout melebihi office time; juga bisa via menu “Overtime”."
    ]
  },
  {
    "date": "7 Maret 2025",
    "items": [
      "Task Based on Target: progress tugas berdasarkan realisasi target qty/nominal; user update progress via aplikasi.",
      "Dashboard HR: tambah chart gelar pendidikan, skill/sertifikasi, tipe kontrak, gender, dan umur.",
      "Project & Task Management: tambah bar chart dan speedo chart."
    ]
  },
  {
    "date": "5 Maret 2025",
    "items": [
      "Koperasi / Savings & Loans (Backend & Aplikasi): set nominal tabungan per bulan (otomatis jadi potongan payroll); cek riwayat tabungan, ajukan pinjaman (otomatis jadi potongan), dan tarik tabungan via aplikasi (butuh update; approval super admin).",
      "Request Attendance (Backend & Aplikasi): karyawan bisa ajukan presensi backdate; yang di-approve jadi data kehadiran sesuai tanggal/waktu.",
      "Leave (Aplikasi): bisa lampirkan file (tak hanya foto).",
      "Lainnya: berbagai perbaikan di aplikasi (update ke versi terbaru)."
    ]
  },
  {
    "date": "9 Februari 2025",
    "items": [
      "Multi Company / Sub Company (Upgrade Besar): kelola holding & anak perusahaan; data karyawan, payroll, project, reimburse, leave, meeting, chat, dll terpisah per company.",
      "Filter per Company di seluruh fitur."
    ]
  },
  {
    "date": "28 Januari 2025",
    "items": [
      "Project bisa tambah/edit via aplikasi (update app terbaru).",
      "Task bisa tambah/edit via aplikasi.",
      "Checklist bisa tambah/edit via aplikasi.",
      "Client: tambah client masih via backend (coming soon).",
      "Leave Allocation: set alokasi per karyawan.",
      "WFH Request, Visit Expense, Kasbon: dapat diajukan via aplikasi (update app terbaru).",
      "Overtime History: dapat dilihat di aplikasi (update app terbaru)."
    ]
  },
  {
    "date": "9 Januari 2025",
    "items": [
      "Attendance with Photo: opsi check in dengan foto (aktifkan di App Settings; update app terbaru).",
      "Kasbon (Aplikasi): pengajuan lewat aplikasi (update app terbaru).",
      "Lembur Hari Libur: bisa tanpa harus checkout.",
      "WFH Request: izinkan check in/out di mana saja pada tanggal yang disetujui (di backend & akan hadir di mobile update selanjutnya)."
    ]
  },
  {
    "date": "29 Desember 2024",
    "items": [
      "Kolabo Accounting hadir! Lihat di menu samping/kanan atas dashboard.",
      "Pengguna Lama Accounting: hubungi Kolabo Support untuk bantuan setup.",
      "Visit Attendance: tersedia di aplikasi dan backend (update aplikasimu)."
    ]
  },
  {
    "date": "23 Desember 2024",
    "items": [
      "Shift Management: jam kerja & hari libur per karyawan.",
      "Daily Task: centang “Is Daily Task” + pilih hari → tugas auto-generate di hari terpilih.",
      "Asset Management: QR Code, relasi ke project/task/karyawan, status penggunaan.",
      "Storage & Item Management (Modul Baru): data item dalam penyimpanan + histori tambah/edit/pindah.",
      "Client Visit (Modul Baru): Visit Attendance untuk tracking tim lapangan (Coming Soon).",
      "Visit Expense / Per Diem: catat pengeluaran perjalanan dinas per range tanggal & nominal.",
      "Roadmap: lebih banyak modul & improvement akan hadir; modul Akunting hadir di 2025."
    ]
  }
]
